import { CanDeactivateFn } from '@angular/router';
import { Observable, take } from 'rxjs';
import { ControllerService } from '../services/controller/controller.service';
import { inject } from '@angular/core';

export const unsavedChangesGuard: CanDeactivateFn<HasChanges> = (component, currentRoute, currentState, nextState) => {
  const controllerService: ControllerService = inject(ControllerService);

  return new Observable<boolean>((observer) => {
    component.isDirty$.pipe(take(1)).subscribe(async (isDirty: boolean) => {
      if (!isDirty) {
        observer.next(true);
        observer.complete();
      } else {
        const confirm = await controllerService.confirm(
          'You have unsaved changes',
          'Do you want to leave without saving?'
        );
        await confirm.present();
        const result = await confirm.onDidDismiss();
        observer.next(result.role === 'destructive');
        observer.complete();
      }
    });
  });
};

export interface HasChanges {
  isDirty$: Observable<boolean>;
  markAsDirty(): void;
  isDirty: boolean;
}
